// extracted by mini-css-extract-plugin
export default {"skeletonItem":"ULUKJjA5XQdV5LMV40A0","changeColorLight":"Bc53CKFhiyX7aqeTXplm","aiSkeletonItem":"YOQ7Ab_gUWZUQS4uHV3y","ai-background":"rSpHT0_2DDk3myCxwkgp"};